import { Component, computed, inject, input, OnInit } from '@angular/core';
import { GbTheme, SubscriberService } from '@gb-webapp/gb-app';
import { TranslatePipe } from '@ngx-translate/core';
import { AppleAuthService } from '../../services/apple-auth/apple-auth.service';
import { GoogleAuthService } from '../../services/google-auth/google-auth.service';
import { ApiConfigService } from '../../ssr-services/api-config/api-config.service';
import { CacheService } from '../../ssr-services/cache/cache.service';

@Component({
  selector: 'app-social-login-buttons',
  templateUrl: './social-login-buttons.component.html',
  styleUrls: ['./social-login-buttons.component.scss'],
  imports: [TranslatePipe],
})
export class SocialLoginButtonsComponent implements OnInit {
  protected googleAuthService = inject(GoogleAuthService);

  public theme = input<GbTheme>();

  public GbTheme = GbTheme;

  protected appleAuthService = inject(AppleAuthService);

  protected subscriberService = inject(SubscriberService);

  public autoRedirectOnSocialLogin = input<boolean>(false);

  public postAuthRedirect = input<{ url?: string; queryParams?: { [key: string]: string } }>({});

  protected apiConfig = inject(ApiConfigService);

  protected cacheService = inject(CacheService);

  public s3BucketAssets = computed(
    () => this.cacheService.cachedContent()?.cache?.config?.webAppConfig?.s3BucketAssets
  );

  constructor() {}

  public ngOnInit(): void {
    this.googleAuthService.loadScript();
  }

  public googleLogin(): Promise<void> {
    return this.googleAuthService.loadScript().then(() => {
      const language = this.subscriberService.subscriberLanguage();
      const currency = this.subscriberService.subscriberCurrency();
      this.googleAuthService.initiateLogin(this.currentUrl(), {
        language: language?.code || '',
        currency: currency?.currency || '',
      });
    });
  }

  public appleLogin() {
    const language = this.subscriberService.subscriberLanguage();
    const currency = this.subscriberService.subscriberCurrency();
    this.appleAuthService.initiateLogin(this.currentUrl(), {
      language: language?.code || '',
      currency: currency?.currency || '',
    });
  }

  public currentUrl(): { url?: string; queryParams?: { [key: string]: string } } | undefined {
    if (this.postAuthRedirect()) {
      return this.postAuthRedirect();
    }

    return this.autoRedirectOnSocialLogin()
      ? { url: globalThis.location.href.replace(this.apiConfig.getHost(), '') }
      : undefined;
  }
}
